import * as Yup from 'yup';
import { DropdownOptions } from '@components/common/formControl/dropdown';

export type IAidModalType = 'aid' | 'carpenter';

export const aidOptions: DropdownOptions[] = [
	{ id: 0, value: 'Yes' },
	{ id: 1, value: 'No' },
];

export interface IAidModalProps {
	type: IAidModalType;
	userId: number;
	closeModal: () => void;
}

export interface IAidModalConfig {
	fieldName: string;
	label: string;
	validation: Yup.AnySchema;
	inputType: 'dropdown' | 'number';
	options?: DropdownOptions[];
}

export interface ICAidQuery {
	userId: number;
	aid?: string;
	carpenters_no?: number;
}

export interface ICAidDataType {
	id: number;
	aid: string;
}
